/** Product copy shared by the business workspace and control center. */
export const lao: Record<string, string> = {
  'Pricing & accounting format': 'ຮູບແບບລາຄາ ແລະ ບັນຊີ',
  'Choose how prices, balances and accounting amounts appear.':
    'ເລືອກຮູບແບບສະແດງລາຄາ, ຍອດເງິນ ແລະ ຈຳນວນເງິນໃນບັນຊີ.',
  'Apply to': 'ນຳໃຊ້ກັບ',
  'Workspace default': 'ຄ່າເລີ່ມຕົ້ນຂອງທຸລະກິດ',
  'Only this browser': 'ສະເພາະບຣາວເຊີນີ້',
  'Used by everyone in this workspace unless they choose a personal format.':
    'ໃຊ້ສຳລັບທຸກຄົນໃນທຸລະກິດນີ້ ຍົກເວັ້ນຜູ້ທີ່ເລືອກຮູບແບບສ່ວນຕົວ.',
  'Your personal display preference on this browser, across workspaces.':
    'ຮູບແບບສະແດງສ່ວນຕົວໃນບຣາວເຊີນີ້ ສຳລັບທຸກທຸລະກິດ.',
  'Decimal mark': 'ເຄື່ອງໝາຍທົດສະນິຍົມ',
  'Number separators': 'ເຄື່ອງໝາຍແຍກຕົວເລກ',
  'Thousands separator': 'ເຄື່ອງໝາຍແບ່ງຫຼັກພັນ',
  Dot: 'ຈຸດ',
  Comma: 'ຈຸດຈ້ຳ',
  Space: 'ຊ່ອງວ່າງ',
  Apostrophe: 'ເຄື່ອງໝາຍອັກສອນຕັດ',
  'Currency label': 'ປ້າຍສະກຸນເງິນ',
  'Currency display': 'ການສະແດງສະກຸນເງິນ',
  'Currency position': 'ຕຳແໜ່ງສະກຸນເງິນ',
  'Before amount': 'ກ່ອນຈຳນວນເງິນ',
  'After amount': 'ຫຼັງຈຳນວນເງິນ',
  'Negative amounts': 'ຈຳນວນເງິນຕິດລົບ',
  'Minus sign': 'ເຄື່ອງໝາຍລົບ',
  'Accounting parentheses': 'ວົງເລັບແບບບັນຊີ',
  'Quantity decimal places': 'ຈຳນວນຫຼັກທົດສະນິຍົມຂອງປະລິມານ',
  'Decimal places': 'ຫຼັກທົດສະນິຍົມ',
  'Decimal precision': 'ຄວາມລະອຽດທົດສະນິຍົມ',
  'Live preview': 'ຕົວຢ່າງຮູບແບບ',
  'Negative balance': 'ຍອດເງິນຕິດລົບ',
  'Display formatting only. Saved prices, calculations and ledger amounts keep their original precision. CSV and Excel exports keep numeric values.':
    'ປັບສະເພາະຮູບແບບສະແດງ. ລາຄາທີ່ບັນທຶກ, ການຄຳນວນ ແລະ ຈຳນວນເງິນໃນບັນຊີຮັກສາຄວາມລະອຽດເດີມ. ການສົ່ງອອກ CSV ແລະ Excel ຮັກສາຄ່າຕົວເລກ.',
  'This browser uses a personal format. Choose Only this browser to use the workspace default.':
    'ບຣາວເຊີນີ້ໃຊ້ຮູບແບບສ່ວນຕົວ. ເລືອກ ສະເພາະບຣາວເຊີນີ້ ເພື່ອກັບໄປໃຊ້ຄ່າຂອງທຸລະກິດ.',
  'Reset to standard format': 'ກັບໄປໃຊ້ຮູບແບບມາດຕະຖານ',
  'Use workspace format': 'ໃຊ້ຮູບແບບຂອງທຸລະກິດ',
  'Tax included': 'ລວມພາສີແລ້ວ',
  'Sale price includes tax': 'ລາຄາຂາຍລວມພາສີແລ້ວ',
  'Payroll employee selection': 'ການເລືອກພະນັກງານສຳລັບເງິນເດືອນ',
  'All eligible employees': 'ພະນັກງານທີ່ມີສິດທັງໝົດ',
  'Choose employees': 'ເລືອກພະນັກງານ',
  'Selected employees': 'ພະນັກງານທີ່ເລືອກ',
  Include: 'ລວມເຂົ້າ',
  'Select at least one employee': 'ເລືອກພະນັກງານຢ່າງໜ້ອຍໜຶ່ງຄົນ',
  'As of report end date': 'ຍອດເຖິງວັນສິ້ນສຸດລາຍງານ',
  'Opening cash balance': 'ຍອດເງິນສົດຕົ້ນງວດ',
  'Closing cash balance': 'ຍອດເງິນສົດທ້າຍງວດ',
  'Record saved. Retry to finish uploading attachments.':
    'ບັນທຶກລາຍການແລ້ວ. ລອງອີກຄັ້ງເພື່ອອັບໂຫຼດໄຟລ໌ແນບໃຫ້ສຳເລັດ.',
  'Posting calculates salaries for the included employees using configured benefits, deductions, tax brackets and social security rates. Overlapping payroll periods for the same employee are blocked.':
    'ການລົງບັນຊີຈະຄິດເງິນເດືອນພະນັກງານທີ່ເລືອກ ຕາມຜົນປະໂຫຍດ, ລາຍການຫັກ, ພາສີ ແລະ ປະກັນສັງຄົມທີ່ຕັ້ງໄວ້. ບໍ່ອະນຸຍາດໃຫ້ຄິດເງິນເດືອນງວດທີ່ຊ້ອນກັນສຳລັບຄົນດຽວກັນ.',
  'My profile': 'ຂໍ້ມູນສ່ວນຕົວ',
  'Current password': 'ລະຫັດຜ່ານປັດຈຸບັນ',
  'New password (optional)': 'ລະຫັດຜ່ານໃໝ່ (ບໍ່ບັງຄັບ)',
  'Repeat new password': 'ປ້ອນລະຫັດຜ່ານໃໝ່ອີກຄັ້ງ',
  'Passwords must match': 'ລະຫັດຜ່ານຕ້ອງກົງກັນ',
  'Profile updated': 'ອັບເດດຂໍ້ມູນແລ້ວ',
  'Update your details. Saving signs out your other sessions.':
    'ແກ້ໄຂຂໍ້ມູນຂອງທ່ານ. ເມື່ອບັນທຶກ ອຸປະກອນອື່ນຈະອອກຈາກລະບົບ.',
  'The shared demo profile cannot be changed': 'ບັນຊີຕົວຢ່າງລວມບໍ່ສາມາດແກ້ໄຂໄດ້',
  Partner: 'ຄູ່ຄ້າ',
  Class: 'ປະເພດ',
  Difference: 'ຜົນຕ່າງ',
  'All reports': 'ລາຍງານທັງໝົດ',
  'Save changes': 'ບັນທຶກການປ່ຽນແປງ',
  'Current records snapshot': 'ຂໍ້ມູນບັນທຶກປັດຈຸບັນ',
  'Schedule only; post depreciation through an adjustment':
    'ຕາຕະລາງຄາດຄະເນ; ລົງບັນຊີຄ່າຫຼຸ້ຍຫ້ຽນຜ່ານລາຍການປັບປຸງ',
  'Based on recorded transactions': 'ຈາກທຸລະກຳທີ່ບັນທຶກແລ້ວ',
  'Record actions': 'ຈັດການລາຍການ',
  'Your platform, in focus.': 'ພາບລວມລະບົບຂອງທ່ານ',
  'Manage every business from one place.': 'ຈັດການທຸກທຸລະກິດໃນບ່ອນດຽວ',
  'A separate home for every business and branch.': 'ພື້ນທີ່ສະເພາະສຳລັບແຕ່ລະທຸລະກິດ ແລະ ສາຂາ',
  'Give the right people the right access.': 'ກຳນົດສິດໃຫ້ເໝາະສົມກັບໜ້າທີ່',
  'Extend each workspace as its business grows.': 'ເພີ່ມຄວາມສາມາດຕາມການເຕີບໂຕຂອງທຸລະກິດ',
  'A record of changes across every workspace.': 'ປະຫວັດການປ່ຽນແປງໃນທຸກທຸລະກິດ',
  'Current status of the local LFB services.': 'ສະຖານະປັດຈຸບັນຂອງບໍລິການ LFB',
  'Choose how businesses receive future releases and patches.':
    'ເລືອກຊ່ອງທາງຮັບອັບເດດ ແລະ ການແກ້ໄຂລະບົບ',
  'API reference': 'ຄູ່ມື API',
  Access: 'ສິດເຂົ້າໃຊ້',
  Account: 'ບັນຊີ',
  'Account balances': 'ຍອດບັນຊີ',
  'Account class': 'ປະເພດບັນຊີ',
  'Account menu': 'ເມນູບັນຊີ',
  'Account number': 'ເລກບັນຊີ',
  'Account type': 'ປະເພດບັນຊີ',
  'Accounting code': 'ລະຫັດບັນຊີ',
  'Accounting code (optional)': 'ລະຫັດບັນຊີ (ບໍ່ບັງຄັບ)',
  'Accounting code filter': 'ຄົ້ນຕາມລະຫັດບັນຊີ',
  'Accumulated depreciation code': 'ລະຫັດຄ່າຫຼຸ້ຍຫ້ຽນສະສົມ',
  'Acquisition value': 'ມູນຄ່າການຊື້',
  Active: 'ເປີດໃຊ້ງານ',
  Adjustment: 'ລາຍການປັບປຸງ',
  'Admin allocation (%)': 'ສັດສ່ວນບໍລິຫານ (%)',
  'Asset account code': 'ລະຫັດບັນຊີຊັບສິນ',
  'Asset code': 'ລະຫັດຊັບສິນ',
  'Balance sheet': 'ໃບດຸນດ່ຽງ',
  'Bank name': 'ຊື່ທະນາຄານ',
  Benefit: 'ຜົນປະໂຫຍດ',
  'Benefit type': 'ປະເພດຜົນປະໂຫຍດ',
  Business: 'ທຸລະກິດ',
  'Changes in equity': 'ການປ່ຽນແປງທຶນ',
  Checked: 'ກວດສອບແລ້ວ',
  'Close navigation': 'ປິດເມນູ',
  'Collapse sidebar': 'ຫຍໍ້ເມນູ',
  'Expand sidebar': 'ຂະຫຍາຍເມນູ',
  Color: 'ສີ',
  Configure: 'ຕັ້ງຄ່າ',
  'Connect Flutter apps and authorized integrations to this workspace.':
    'ເຊື່ອມຕໍ່ແອັບ Flutter ແລະ ລະບົບທີ່ອະນຸຍາດເຂົ້າກັບທຸລະກິດນີ້',
  'Conversion factor': 'ອັດຕາປ່ຽນຫົວໜ່ວຍ',
  'Copy invitation link': 'ຄັດລອກລິ້ງເຊີນ',
  'Copy key': 'ຄັດລອກກະແຈ',
  'Cost allocation (%)': 'ສັດສ່ວນຕົ້ນທຶນ (%)',
  'Cost method': 'ວິທີຄິດຕົ້ນທຶນ',
  'Counted closing cash': 'ເງິນສົດທີ່ນັບໄດ້ເມື່ອປິດຮອບ',
  'Create API key': 'ສ້າງກະແຈ API',
  'Create invitation': 'ສ້າງຄຳເຊີນ',
  'Create key': 'ສ້າງກະແຈ',
  'Credit limit': 'ວົງເງິນສິນເຊື່ອ',
  'Currency code': 'ລະຫັດສະກຸນເງິນ',
  DEMO: 'ຕົວຢ່າງ',
  'Default currency': 'ສະກຸນເງິນເລີ່ມຕົ້ນ',
  'Default due days': 'ຈຳນວນມື້ກ່ອນຄົບກຳນົດ',
  'Depreciation expense code': 'ລະຫັດລາຍຈ່າຍຄ່າຫຼຸ້ຍຫ້ຽນ',
  'Depreciation schedule': 'ຕາຕະລາງຄ່າຫຼຸ້ຍຫ້ຽນ',
  Direction: 'ທິດທາງ',
  'Document footer': 'ຂໍ້ຄວາມທ້າຍເອກະສານ',
  'Document type': 'ປະເພດເອກະສານ',
  Done: 'ສຳເລັດ',
  'Download template': 'ດາວໂຫຼດແບບຟອມ',
  'Edit release metadata': 'ແກ້ໄຂຂໍ້ມູນຮຸ່ນ',
  'Effective salary tax (%)': 'ອັດຕາພາສີເງິນເດືອນ (%)',
  'Employee SSO (%)': 'ປະກັນສັງຄົມພະນັກງານ (%)',
  'Employee code': 'ລະຫັດພະນັກງານ',
  Enterprise: 'ອົງກອນ',
  'Exchange rate to LAK': 'ອັດຕາແລກປ່ຽນເປັນກີບ',
  'Expense account code': 'ລະຫັດບັນຊີລາຍຈ່າຍ',
  'Expense by vendor': 'ລາຍຈ່າຍຕາມຜູ້ສະໜອງ',
  'Expense summary': 'ສະຫຼຸບລາຍຈ່າຍ',
  'Expired & expiring stock': 'ສິນຄ້າໝົດອາຍຸ ແລະ ໃກ້ໝົດອາຍຸ',
  Expires: 'ໝົດອາຍຸ',
  'Finished product': 'ສິນຄ້າສຳເລັດຮູບ',
  'Finished quantity': 'ຈຳນວນສິນຄ້າສຳເລັດ',
  'Fixed asset': 'ຊັບສິນຖາວອນ',
  'Fixed asset register': 'ທະບຽນຊັບສິນຖາວອນ',
  'From account': 'ຈາກບັນຊີ',
  'From amount': 'ຈາກຈຳນວນເງິນ',
  'From unit': 'ຈາກຫົວໜ່ວຍ',
  'From warehouse': 'ຈາກສາງ',
  'General journal report': 'ລາຍງານປຶ້ມບັນຊີປະຈຳວັນ',
  'General ledger': 'ປຶ້ມບັນຊີແຍກປະເພດ',
  'In service date': 'ວັນເລີ່ມໃຊ້ງານ',
  'Income account code': 'ລະຫັດບັນຊີລາຍຮັບ',
  'Income by customer': 'ລາຍຮັບຕາມລູກຄ້າ',
  'Income statement': 'ໃບລາຍງານຜົນການດຳເນີນງານ',
  'Income summary': 'ສະຫຼຸບລາຍຮັບ',
  'Input VAT': 'ອາກອນມູນຄ່າເພີ່ມຂາເຂົ້າ',
  'Output VAT': 'ອາກອນມູນຄ່າເພີ່ມຂາອອກ',
  'Integration events': 'ເຫດການເຊື່ອມຕໍ່',
  'Inventory account code': 'ລະຫັດບັນຊີສິນຄ້າຄົງເຫຼືອ',
  'Inventory valuation': 'ມູນຄ່າສິນຄ້າຄົງເຫຼືອ',
  'Journal entry': 'ລາຍການບັນຊີ',
  'LFB PLATFORM': 'ລະບົບ LFB',
  'LFB help': 'ຊ່ວຍເຫຼືອ LFB',
  'LFB home': 'ໜ້າຫຼັກ LFB',
  Language: 'ພາສາ',
  'Long-term support': 'ຮອງຮັບໄລຍະຍາວ',
  'Lot number': 'ເລກລັອດ',
  'Lowercase letters, numbers and hyphens.': 'ໃຊ້ຕົວອັກສອນອັງກິດນ້ອຍ, ຕົວເລກ ແລະ ຂີດຕໍ່',
  'Main navigation': 'ເມນູຫຼັກ',
  Manage: 'ຈັດການ',
  'Manage memberships': 'ຈັດການສະມາຊິກ',
  Manager: 'ຜູ້ຈັດການ',
  'Mark paid': 'ບັນທຶກວ່າຈ່າຍແລ້ວ',
  'Material product': 'ວັດຖຸດິບ',
  'Material quantity': 'ຈຳນວນວັດຖຸດິບ',
  Member: 'ສະມາຊິກ',
  Members: 'ສະມາຊິກ',
  'Membership limit': 'ຈຳນວນສະມາຊິກສູງສຸດ',
  Model: 'ຮຸ່ນ',
  'Money transfer': 'ການໂອນເງິນ',
  'No records for this period': 'ບໍ່ມີລາຍການໃນໄລຍະນີ້',
  Notifications: 'ການແຈ້ງເຕືອນ',
  'Open API reference': 'ເປີດຄູ່ມື API',
  'Open API specification': 'ເປີດຂໍ້ກຳນົດ API',
  'Open navigation': 'ເປີດເມນູ',
  'Opening balance': 'ຍອດຍົກມາ',
  'Opening cash': 'ເງິນສົດເປີດຮອບ',
  'Order number': 'ເລກຄຳສັ່ງ',
  'Other deductions': 'ລາຍການຫັກອື່ນ',
  'Overhead category': 'ໝວດຄ່າໃຊ້ຈ່າຍຜະລິດ',
  'Overhead cost': 'ຄ່າໃຊ້ຈ່າຍຜະລິດ',
  'Paid from account (leave empty for opening capital)': 'ຈ່າຍຈາກບັນຊີ (ປ່ອຍຫວ່າງສຳລັບທຶນຍົກມາ)',
  'Parent code': 'ລະຫັດບັນຊີຫຼັກ',
  'Pay date': 'ວັນຈ່າຍ',
  'Payables aging': 'ອາຍຸເຈົ້າໜີ້',
  'Payroll payment account': 'ບັນຊີຈ່າຍເງິນເດືອນ',
  'Payroll report': 'ລາຍງານເງິນເດືອນ',
  'Pending invitations': 'ຄຳເຊີນທີ່ລໍຖ້າ',
  'Period close': 'ປິດງວດບັນຊີ',
  'Period end': 'ວັນສິ້ນສຸດງວດ',
  'Period start': 'ວັນເລີ່ມງວດ',
  'Platform admin': 'ຜູ້ດູແລລະບົບ',
  'Post depreciation': 'ລົງບັນຊີຄ່າຫຼຸ້ຍຫ້ຽນ',
  Preview: 'ທົດລອງ',
  'Product category': 'ໝວດສິນຄ້າ',
  'Product purchases': 'ການຊື້ຕາມສິນຄ້າ',
  'Product sales': 'ການຂາຍຕາມສິນຄ້າ',
  'Production order': 'ຄຳສັ່ງຜະລິດ',
  'Rate (%)': 'ອັດຕາ (%)',
  'Rate to LAK': 'ອັດຕາເປັນກີບ',
  'Read and write': 'ອ່ານ ແລະ ຂຽນ',
  'Read only': 'ອ່ານຢ່າງດຽວ',
  'Receivables aging': 'ອາຍຸລູກໜີ້',
  'Received amount': 'ຈຳນວນເງິນທີ່ຮັບ',
  'Recent activity': 'ການໃຊ້ງານລ່າສຸດ',
  'Reference prefix': 'ຄຳນຳໜ້າເລກອ້າງອີງ',
  'Release channels': 'ຊ່ອງທາງອັບເດດ',
  'Release notes': 'ລາຍລະອຽດອັບເດດ',
  'Release track': 'ຊ່ອງທາງອັບເດດ',
  'Remove access': 'ຖອນສິດເຂົ້າໃຊ້',
  'Remove membership': 'ຖອນສະມາຊິກ',
  'Reopen period': 'ເປີດງວດຄືນ',
  'Report from date': 'ວັນເລີ່ມລາຍງານ',
  'Report to date': 'ວັນສິ້ນສຸດລາຍງານ',
  'Reporting period': 'ໄລຍະລາຍງານ',
  'Residual value': 'ມູນຄ່າຄົງເຫຼືອ',
  Revoke: 'ຖອນກະແຈ',
  'Salary tax bracket': 'ຂັ້ນພາສີເງິນເດືອນ',
  'Sale session': 'ຮອບການຂາຍ',
  'Sales allocation (%)': 'ສັດສ່ວນການຂາຍ (%)',
  'Save release metadata': 'ບັນທຶກຂໍ້ມູນຮຸ່ນ',
  'Saved events awaiting an integration consumer.': 'ເຫດການທີ່ບັນທຶກໄວ້ ແລະ ລໍຖ້າລະບົບເຊື່ອມຕໍ່',
  'Search activity…': 'ຄົ້ນຫາປະຫວັດ…',
  'Search members…': 'ຄົ້ນຫາສະມາຊິກ…',
  'Search workspaces…': 'ຄົ້ນຫາທຸລະກິດ…',
  'Select LAK payment account…': 'ເລືອກບັນຊີຈ່າຍເງິນກີບ…',
  'Service status': 'ສະຖານະບໍລິການ',
  'Skip to content': 'ຂ້າມໄປເນື້ອຫາ',
  Stable: 'ສະຖຽນ',
  'Start date': 'ວັນເລີ່ມ',
  Starter: 'ເລີ່ມຕົ້ນ',
  'Statement of cash flows': 'ໃບລາຍງານກະແສເງິນສົດ',
  'Stock lot': 'ລັອດສິນຄ້າ',
  'Stock movement': 'ການເຄື່ອນໄຫວສິນຄ້າ',
  'Stock movement summary': 'ສະຫຼຸບການເຄື່ອນໄຫວສິນຄ້າ',
  'Stock transfer': 'ການໂອນສິນຄ້າ',
  Suspended: 'ລະງັບ',
  Symbol: 'ສັນຍາລັກ',
  Tag: 'ປ້າຍ',
  'Tax (%)': 'ພາສີ (%)',
  'Tax declaration summary': 'ສະຫຼຸບການແຈ້ງພາສີ',
  'Tax rate': 'ອັດຕາພາສີ',
  'To account': 'ເຂົ້າບັນຊີ',
  'To amount': 'ເຖິງຈຳນວນເງິນ',
  'To unit': 'ເປັນຫົວໜ່ວຍ',
  'To warehouse': 'ເຂົ້າສາງ',
  'Transaction summary': 'ສະຫຼຸບທຸລະກຳ',
  'Trial balance': 'ງົບດຸນທົດລອງ',
  'Try a different date range, or post a transaction first.':
    'ເລືອກໄລຍະອື່ນ ຫຼື ລົງບັນຊີທຸລະກຳກ່ອນ',
  Unit: 'ຫົວໜ່ວຍ',
  'Unit conversion': 'ການປ່ຽນຫົວໜ່ວຍ',
  'Unit cost': 'ຕົ້ນທຶນຕໍ່ຫົວໜ່ວຍ',
  'Upload a CSV using the template column names. Imports create drafts; review and post transactions separately.':
    'ນຳເຂົ້າ CSV ຕາມຖັນໃນແບບຟອມ. ທຸລະກຳຈະເປັນຮ່າງເພື່ອກວດສອບກ່ອນລົງບັນຊີ',
  Use: 'ໃຊ້',
  'Useful life (years)': 'ອາຍຸການໃຊ້ງານ (ປີ)',
  Version: 'ຮຸ່ນ',
  'Work in progress': 'ວຽກລະຫວ່າງຜະລິດ',
  'Workspace address': 'ທີ່ຢູ່ທຸລະກິດ',
  'assigned workspaces': 'ທຸລະກິດທີ່ມອບໝາຍ',
  businesses: 'ທຸລະກິດ',
  'e.g. Flutter inventory app': 'ຕົວຢ່າງ: ແອັບສາງ Flutter',
  'rows ready for validation and import.': 'ແຖວພ້ອມກວດສອບ ແລະ ນຳເຂົ້າ',
  'rows ·': 'ແຖວ ·',
  'to collapse or expand the sidebar.': 'ເພື່ອຫຍໍ້ ຫຼື ຂະຫຍາຍເມນູ',
  'to find a module.': 'ເພື່ອຄົ້ນຫາໝວດວຽກ',
  'workspace assignments': 'ທຸລະກິດທີ່ມອບໝາຍ',
  'workspace memberships': 'ສະມາຊິກທຸລະກິດ',
  records: 'ລາຍການ',
  'Close session': 'ປິດຮອບການຂາຍ',
  'Expected cash': 'ເງິນສົດທີ່ຄວນມີ',
  Variance: 'ຜົນຕ່າງ',
  'Depreciate through': 'ຄິດຄ່າຫຼຸ້ຍຫ້ຽນເຖິງ',
  'Depreciation posted': 'ລົງບັນຊີຄ່າຫຼຸ້ຍຫ້ຽນແລ້ວ',
  'Monthly straight-line depreciation will be posted to the ledger.':
    'ຈະລົງບັນຊີຄ່າຫຼຸ້ຍຫ້ຽນລາຍເດືອນດ້ວຍວິທີເສັ້ນຊື່',
  'Closing reconciles counted cash with posted sales and locks the session.':
    'ການປິດຮອບຈະທຽບເງິນສົດທີ່ນັບໄດ້ກັບຍອດຂາຍ ແລະ ລັອກຮອບນີ້',
  'Save a draft, then review and post it when ready.': 'ບັນທຶກຮ່າງ ແລະ ກວດສອບກ່ອນລົງບັນຊີ',
  'No email has been sent. Share this link directly with':
    'ຍັງບໍ່ໄດ້ສົ່ງອີເມວ. ສົ່ງລິ້ງນີ້ໂດຍກົງໃຫ້',
  'Track assignments configure release eligibility. Deployments are managed separately.':
    'ການມອບໝາຍຊ່ອງທາງກຳນົດສິດຮັບອັບເດດ. ການຕິດຕັ້ງຮຸ່ນຈັດການແຍກຕ່າງຫາກ',
  'Disabling an add-on retains its records. Disabling Mobile API revokes the workspace’s existing API keys.':
    'ປິດສ່ວນເສີມແລ້ວຍັງເກັບຂໍ້ມູນໄວ້. ການປິດ Mobile API ຈະຖອນກະແຈ API ທີ່ມີຢູ່',
  'Connect a worker to deliver integration events.': 'ເຊື່ອມຕໍ່ຕົວປະມວນຜົນເພື່ອສົ່ງເຫດການ',
  'Manage businesses, memberships, add-ons and release assignments in the separate control center.':
    'ຈັດການທຸລະກິດ, ສະມາຊິກ, ສ່ວນເສີມ ແລະ ຊ່ອງທາງອັບເດດໃນສູນຄວບຄຸມ',
  'Keys are restricted to this workspace, expire after 90 days, and are stored as hashes. A write key follows your role permissions.':
    'ກະແຈໃຊ້ໄດ້ສະເພາະທຸລະກິດນີ້, ໝົດອາຍຸໃນ 90 ມື້ ແລະ ເກັບແບບແຮຊ. ສິດຂຽນຂຶ້ນກັບບົດບາດຂອງທ່ານ',
  'Use a bearer token and the workspace header. Send an Idempotency-Key when creating transactions from a mobile client.':
    'ໃຊ້ bearer token ແລະ ຫົວຂໍ້ທຸລະກິດ. ສົ່ງ Idempotency-Key ເມື່ອສ້າງທຸລະກຳຈາກມືຖື',
  'PDF, images or CSV · 5 MB per file': 'PDF, ຮູບພາບ ຫຼື CSV · ບໍ່ເກີນ 5 MB ຕໍ່ໄຟລ໌',
  'Up to 500 rows per import. Related records use their IDs. Items and journal entries use JSON arrays in one CSV cell. The whole import is rejected if any row fails validation.':
    'ນຳເຂົ້າໄດ້ສູງສຸດ 500 ແຖວ. ໃຊ້ ID ສຳລັບລາຍການອ້າງອີງ ແລະ JSON ສຳລັບສິນຄ້າ ຫຼື ລາຍການບັນຊີ. ຖ້າມີແຖວໃດບໍ່ຖືກຕ້ອງ ຈະຍົກເລີກການນຳເຂົ້າທັງໝົດ',
  'Tax and social security rates are configurable. Have your accountant verify applicable rates and reporting rules before using live payroll or tax reports.':
    'ອັດຕາພາສີ ແລະ ປະກັນສັງຄົມປັບໄດ້. ໃຫ້ນັກບັນຊີກວດອັດຕາ ແລະ ກົດລະບຽບກ່ອນໃຊ້ງານຈິງ',
  'Save transactions as drafts, review their details, then post them to update accounting and stock balances.':
    'ບັນທຶກທຸລະກຳເປັນຮ່າງ, ກວດສອບ ແລະ ລົງບັນຊີເພື່ອອັບເດດຍອດບັນຊີ ແລະ ສາງ',
  'Posting calculates salaries for all active employees in the selected department, using configured benefits, deductions, tax brackets and social security rates. Review the posted run before marking it paid.':
    'ການລົງບັນຊີຈະຄິດເງິນເດືອນພະນັກງານທີ່ເປີດໃຊ້ໃນພະແນກທີ່ເລືອກ ຕາມຜົນປະໂຫຍດ, ລາຍການຫັກ, ພາສີ ແລະ ປະກັນສັງຄົມທີ່ຕັ້ງໄວ້. ກວດສອບກ່ອນບັນທຶກການຈ່າຍ',
};
